import axios from 'axios';

function isDuplicateCopy(err) {
  if (err?.response?.status !== 409) return null;
  const detail = err.response?.data?.detail;
  if (detail && typeof detail === 'object' && !Array.isArray(detail)) {
    if (detail.code === 'duplicate_copy' || detail.message) return detail;
  }
  if (typeof detail === 'string' && /already|another copy/i.test(detail)) {
    return { message: detail, code: 'duplicate_copy' };
  }
  return null;
}

export async function postBook(API, token, payload) {
  try {
    return await axios.post(`${API}/books`, payload, {
      headers: { Authorization: `Bearer ${token}` },
    });
  } catch (err) {
    const detail = isDuplicateCopy(err);
    if (detail) {
      const ok = window.confirm(
        detail.message || 'This book already exists on MyBook.Rent. Add another copy?'
      );
      if (!ok) {
        const cancelled = new Error('cancelled');
        cancelled.cancelled = true;
        throw cancelled;
      }
      return await axios.post(
        `${API}/books`,
        { ...payload, confirm_another_copy: true },
        { headers: { Authorization: `Bearer ${token}` } }
      );
    }
    throw err;
  }
}
